import { render, staticRenderFns } from "./mobleTip.vue?vue&type=template&id=df3cdf36&scoped=true"
import script from "./mobleTip.vue?vue&type=script&lang=js"
export * from "./mobleTip.vue?vue&type=script&lang=js"
import style0 from "./mobleTip.vue?vue&type=style&index=0&id=df3cdf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3cdf36",
  null
  
)

export default component.exports